
class VariantSelector extends HTMLElement {
    constructor() {
        super();
        this.allVariants = this.getVariantJSON();
        this.desktopStyle = window.getComputedStyle(document.querySelector('.product-desktop'));
        this.isDesktop = this.desktopStyle.display !== 'none';
        this.selectOptions = this.querySelectorAll('.product-mobile-drop option');
        this.radioOptions = this.querySelectorAll('input[type="radio"].radios');
        this.inputOptions = this.isDesktop ? this.radioOptions : this.selectOptions;
        this.addEventListener("change", this.onVariantChange.bind(this));
        this.keepThis = {
            "option1": [],
            "option2": [],
            "option3": [],
        };
        this.availableOptions = {
            "option1": [],
            "option2": [],
            "option3": [],
        };
        this.disableUnavailableOptionsOnLoad();
        this.selectedOptions = {};

    }

    onVariantChange(e) {
        const selectedOptionCategory = e.target.name.split("[")[1].replace("]", "");
        const changedOption = e.target.value;
        const customNailInput = this.querySelector(".custom-nail-input");
        const customNailMeasurementTextarea = this.querySelector("#custom-nail-measurement");

        if (selectedOptionCategory === "option1" && changedOption === "Custom") {
            if (changedOption === "Custom") {
                // show and enable textarea for custom measurements
                customNailInput.style.display = "block";
                customNailMeasurementTextarea.removeAttribute("disabled");
                customNailMeasurementTextarea.setAttribute("required", "true");
            } else {
                customNailInput.style.display = "none";
                customNailMeasurementTextarea.value = "";
                customNailMeasurementTextarea.setAttribute("disabled", "disabled");
                customNailMeasurementTextarea.removeAttribute("required");
            }
        }

        // store previously selected options before updating
        const previouslySelectedOptions = { ...this.selectedOptions };

        // update selected option
        if (changedOption !== "CustomMeasurement") {
            this.selectedOptions[selectedOptionCategory] = changedOption;
        }

        this.availableOptions = {
            "option1": [],
            "option2": [],
            "option3": [],
        }

        // update options based on selected combination
        this.updateOptions(selectedOptionCategory);

        this.getSelectedOptions();
        this.getSelectedVariant();

        if(this.currentVariant) {
            this.updateURL();
            this.updateFormID();
            this.updatePrice();
        }

        // loop through options
        // if the option value is the same as changedOption
            // and if it has the disabled class, then remove it
        this.inputOptions.forEach(option => {
            if (option.value === changedOption) {
                if (option.classList.contains("disabled")) {
                    // uncheck radio buttons that are no longer valid
                    this.uncheckInvalidRadioButtons(previouslySelectedOptions);

                    option.classList.remove("disabled");
                }


            }
        })

        this.previouslySelectedOption = changedOption;
    }

    getSelectedOptions() {
        const selectOptionValues = Array.from(this.querySelectorAll('.product-mobile-drop option:checked'), (select) => select.value);

        const radioOptionValues = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (input) => input.value)

        const valuesToExclude = ["Select Size", "Select Length", "Select Shape"]

        this.options = radioOptionValues.length === 0 ? selectOptionValues : radioOptionValues;
        this.options = this.options.filter(value => !valuesToExclude.includes(value));

        // check if all three options are selected
        const allOptionsSelected = this.options.length === 3;
        const checkoutButton = document.querySelector('.button-add-cart');
        checkoutButton.disabled = !allOptionsSelected;
        !allOptionsSelected ? checkoutButton.classList.add('button-disabled') : checkoutButton.classList.remove('button-disabled');
    }

    getVariantJSON() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    disableUnavailableOptionsOnLoad() {
        const availableVariants = this.allVariants.filter(variant => {
            return variant.available === true;
        });

        const optionsToKeep = availableVariants.map(variant => {
            const options = [ variant.option1, variant.option2, variant.option3 ];

            if (!this.keepThis["option1"].includes(variant.option1)) {
                this.keepThis["option1"].push(variant.option1);
            }

            if (!this.keepThis["option2"].includes(variant.option2)) {
                this.keepThis["option2"].push(variant.option2);
            }

            if (!this.keepThis["option3"].includes(variant.option3)) {
                this.keepThis["option3"].push(variant.option3);
            }

            return options;
        })

        if (availableVariants.length === 0) {
            // completely out of stock
            this.inputOptions.forEach(input => input.disabled = true)
        } else {
            this.inputOptions.forEach(input => {
                if (!optionsToKeep.some(optionsArray => optionsArray.includes(input.value))) {
                    // option is not selected or is an unavailable option
                    input.disabled = true;
                }
            })
        }
    }

    getSelectedVariant() {
        this.currentVariant = this.allVariants.find(
            (variant) => {
                const foundOption = !variant.options.map(
                    (option, index) => {
                        return this.options[index] === option;
                    }
                ).includes(false);

                if(foundOption) return variant;
            }
        );
    }

    updateOptions(selectedOptionCategory) {
        // reset available options
        this.availableOptions = {
            "option1": [],
            "option2": [],
            "option3": []
        }

        // update available variants based on selected options
        const selectedOptionsArray = Object.values(this.selectedOptions);
        const selectedOptionsCategories = Object.keys(this.selectedOptions);
        let availableVariants;

        // if the option selected by the user is in a category that has previously been selected
        if (this.selectedOptions[selectedOptionCategory]) {
            const firstFilter = this.allVariants.filter(variant => {
                if (selectedOptionsArray.length > 1) {
                    return variant.available && selectedOptionsArray.includes(variant[selectedOptionCategory]);
                } else {
                    return variant.available && (
                        selectedOptionsArray.includes(variant.option1) ||
                        selectedOptionsArray.includes(variant.option2) ||
                        selectedOptionsArray.includes(variant.option3)
                    )
                }
            })

            firstFilter.forEach(variant => {
                Object.keys(this.availableOptions).forEach(optionCategory => {
                    if (variant.available) {
                        const optionValue = variant[optionCategory];
                        if (optionValue && !this.availableOptions[optionCategory].includes(optionValue)) {
                            this.availableOptions[optionCategory].push(optionValue);
                        }
                    }
                });
            });

            availableVariants = firstFilter;

        } else {
            availableVariants = this.allVariants.filter(variant => {
                if (selectedOptionsArray.length < 2) {
                    return variant.available && (
                        selectedOptionsArray.includes(variant.option1) ||
                        selectedOptionsArray.includes(variant.option2) ||
                        selectedOptionsArray.includes(variant.option3)
                    )
                } else {
                    let isSelectedCombination = true;
                    for (let i = 0; i < selectedOptionsCategories.length; i++) {
                        const category = selectedOptionsCategories[i];
                        const optionValue = selectedOptionsArray[i];

                        if (variant[category] !== optionValue) {
                            isSelectedCombination = false;
                            break;
                        }
                    }

                    return variant.available && isSelectedCombination;
                }
            })

        }

        // determine which options should be kept enabled
        if (availableVariants.length > 0) {
            const optionsToKeepSet = new Set();
            availableVariants.forEach(variant => {
                optionsToKeepSet.add(variant.option1);
                optionsToKeepSet.add(variant.option2);
                optionsToKeepSet.add(variant.option3);
            })

            const optionsToKeep = Array.from(optionsToKeepSet);

            const excludeOption1 = ['XS', 'S', 'M', 'L', 'XL'];
            const excludeOption2 = ['Short', 'Medium', 'Long'];
            const excludeOption3 = ['Almond', 'Oval', 'Square', 'Coffin', 'Stiletto'];

            this.inputOptions.forEach(radioInput => {
                if (Object.keys(this.selectedOptions).length < 2) {
                    const filteredSet = new Set();
                    optionsToKeep.forEach(option => filteredSet.add(option));

                    if (selectedOptionCategory === 'option1') {
                        Object.values(this.keepThis).forEach(array => {
                            array.forEach(value => {
                                if (excludeOption1.includes(value)) {
                                    filteredSet.add(value);
                                }
                            })
                        })
                    }

                    if (selectedOptionCategory === 'option2') {
                        Object.values(this.keepThis).forEach(array => {
                            array.forEach(value => {
                                if (excludeOption2.includes(value)) {
                                    filteredSet.add(value);
                                }
                            })
                        })
                    }

                    if (selectedOptionCategory === 'option3') {
                        Object.values(this.keepThis).forEach(array => {
                            array.forEach(value => {
                                if (excludeOption3.includes(value)) {
                                    filteredSet.add(value);
                                }
                            })
                        })
                    }

                    const filteredKeepThis = Array.from(filteredSet);

                    if (!filteredKeepThis.includes(radioInput.value)) {
                            if (this.isDesktop) {
                                radioInput.classList.add("disabled");
                            } else {
                                radioInput.disabled = true;
                            }
                    }
                } else {
                    const filteredSet = new Set();
                    optionsToKeep.forEach(option => filteredSet.add(option));

                    if (selectedOptionCategory === 'option1') {
                        Object.values(this.keepThis).forEach(array => {
                            array.forEach(value => {
                                if (excludeOption1.includes(value)) {
                                    filteredSet.add(value);
                                }
                            })
                        })
                    }

                    if (selectedOptionCategory === 'option2') {
                        Object.values(this.keepThis).forEach(array => {
                            array.forEach(value => {
                                if (excludeOption2.includes(value)) {
                                    filteredSet.add(value);
                                }
                            })
                        })
                    }

                    if (selectedOptionCategory === 'option3') {
                        Object.values(this.keepThis).forEach(array => {
                            array.forEach(value => {
                                if (excludeOption3.includes(value)) {
                                    filteredSet.add(value);
                                }
                            })
                        })
                    }

                    const filteredKeepThis = Array.from(filteredSet);

                    if (!filteredKeepThis.includes(radioInput.value) && !["Select Size", "Select Length", "Select Shape"].includes(radioInput.value)) {
                        if (this.isDesktop) {
                            radioInput.classList.add("disabled");
                            if (radioInput.checked) radioInput.checked = false;
                        } else {
                            radioInput.disabled = true;
                            if (selectedOptionCategory === 'option1') {
                                if (radioInput.value) radioInput.value = 'Select Size';
                            }

                            if (selectedOptionCategory === 'option2') {
                                if (radioInput.value) radioInput.value = 'Select Length';
                            }

                            if (selectedOptionCategory === 'option3') {
                                if (radioInput.value) radioInput.value = 'Select Shape';
                            }

                        }
                    }
                }


                optionsToKeep.forEach(option => {
                    if (option === radioInput.value) {
                        if (radioInput.classList.contains("disabled")) {
                            radioInput.classList.remove("disabled");
                        }

                        if (!this.isDesktop) {
                            radioInput.disabled = false;
                        }
                    }

                })
            })
        }
    }


    uncheckInvalidRadioButtons(previouslySelectedOptions) {
        this.radioOptions.forEach(radioInput => {
            const category = radioInput.getAttribute("name").split("[")[1].replace("]", "");
            const isValid = this.isRadioInputValid(radioInput);

            // uncheck radio inputs that are no longer valid
            if (!isValid) radioInput.checked = false;

            // disable radio inputs that are not valid for the new selection
            const newSelectedOptions = { ...previouslySelectedOptions, [category]: radioInput.value };
            const newIsValid = this.isRadioInputValid(radioInput, newSelectedOptions);

            if (!newIsValid) {
                radioInput.classList.add("disabled");
            } else {
                radioInput.classList.remove("disabled");
            }
        })
    }

    isRadioInputValid(radioInput, selectedOptions = this.selectedOptions) {
        const selectedOptionsArray = Object.values(selectedOptions);
        const selectedOptionsCategories = Object.keys(selectedOptions);

        const availableVariants = this.allVariants.filter(variant => {
            if (selectedOptionsArray.length < 2) {
                return variant.available && (
                    selectedOptionsArray.includes(variant.option1) ||
                    selectedOptionsArray.includes(variant.option2) ||
                    selectedOptionsArray.includes(variant.option3)
                )
            } else {
                let isSelectedCombination = true;

                for (let i = 0; i < selectedOptionsCategories.length; i++) {
                    const category = selectedOptionsCategories[i];
                    const optionValue = selectedOptionsArray[i];
                    if (variant[category] !== optionValue) {
                        isSelectedCombination = false;
                        break;
                    }
                }

                return variant.available && isSelectedCombination;
            }
        })

        return Object.values(availableVariants).some(optionsArray => optionsArray.includes(radioInput.value));


    }

    updateURL() {
        if(!this.currentVariant) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateFormID() {
        const form_input = document.querySelector("#product-form").querySelector('input[name="id"]');
        form_input.value = this.currentVariant.id;
    }

    updatePrice() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
            const id = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const oldPrice = document.getElementById(id);
            const newPrice = html.getElementById(id);

            if(oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
        });
    }
}

customElements.define('variant-selector', VariantSelector);
